import React from "react";
import {logout} from "@platform/platform-auth/src";

export const LogoutPage = () => {
    logout();
    return <p>Logging out...</p>;
};
